import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const BANNER_IMG = "https://images.unsplash.com/photo-1639751787355-bbc3ed1fd639?w=1400&q=85";

const portfolioItems = [
  { id: 1, category: "Kitchen", title: "Contemporary Kitchen Renovation", location: "Toronto, ON", img: "https://images.unsplash.com/photo-1639751787355-bbc3ed1fd639?w=700&q=80" },
  { id: 2, category: "Kitchen", title: "Modern Kitchen with Island", location: "Mississauga, ON", img: "https://images.unsplash.com/photo-1638886043487-72d203fa66b6?w=700&q=80" },
  { id: 3, category: "Bathroom", title: "Luxury Master Bathroom", location: "Hamilton, ON", img: "https://images.unsplash.com/photo-1774578342098-66adff9c1fe1?w=700&q=80" },
  { id: 4, category: "Bathroom", title: "Spa-Style Bathroom", location: "Burlington, ON", img: "https://images.pexels.com/photos/32998547/pexels-photo-32998547.jpeg?auto=compress&cs=tinysrgb&w=700" },
  { id: 5, category: "Basement", title: "Finished Family Basement", location: "Oakville, ON", img: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=700&q=80" },
  { id: 6, category: "Living", title: "Open-Concept Living Space", location: "London, ON", img: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=700&q=80" },
  { id: 7, category: "Custom Build", title: "Custom Home Build", location: "Barrie, ON", img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=700&q=80" },
  { id: 8, category: "Commercial", title: "Commercial Office Renovation", location: "Kitchener, ON", img: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=700&q=80" },
  { id: 9, category: "Flooring", title: "Hardwood & Tile Flooring", location: "Guelph, ON", img: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=700&q=80" },
  { id: 10, category: "Living", title: "Master Bedroom Makeover", location: "Cambridge, ON", img: "https://images.unsplash.com/photo-1540518614846-7eded433c457?w=700&q=80" },
  { id: 11, category: "Custom Build", title: "Second-Storey Addition", location: "Brampton, ON", img: "https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=700&q=80" },
  { id: 12, category: "Commercial", title: "Retail Space Renovation", location: "Waterloo, ON", img: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=700&q=80" },
];

const categories = ["All", "Kitchen", "Bathroom", "Basement", "Living", "Flooring", "Custom Build", "Commercial"];

export default function Portfolio() {
  const [active, setActive] = useState("All");

  const filtered = active === "All" ? portfolioItems : portfolioItems.filter(p => p.category === active);

  return (
    <main data-testid="portfolio-page">

      {/* BANNER */}
      <section
        className="relative h-72 md:h-96 pt-20 flex items-end"
        style={{ backgroundImage: `url(${BANNER_IMG})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
      >
        <div className="absolute inset-0 bg-slate-950/70" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pb-12 w-full">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#00A2E8] mb-2">OUR WORK</p>
          <h1 className="text-4xl md:text-5xl font-black uppercase tracking-tighter text-white leading-none">
            Project Portfolio
          </h1>
        </div>
      </section>

      {/* FILTER & GRID */}
      <section className="py-20 md:py-28 bg-white" data-testid="portfolio-grid-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">

          {/* Filter Tabs */}
          <div className="flex flex-wrap gap-2 mb-12" data-testid="portfolio-filters">
            {categories.map(cat => (
              <button
                key={cat}
                data-testid={`filter-${cat.toLowerCase().replace(' ', '-')}`}
                onClick={() => setActive(cat)}
                className={`px-5 py-2 text-sm font-bold tracking-wide border-2 transition-all duration-200 ${
                  active === cat
                    ? 'bg-[#00A2E8] border-[#00A2E8] text-white'
                    : 'bg-white border-slate-200 text-slate-600 hover:border-[#00A2E8] hover:text-[#00A2E8]'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map(item => (
              <div
                key={item.id}
                data-testid={`portfolio-item-${item.id}`}
                className="group overflow-hidden bg-slate-50 border border-slate-100"
              >
                <div className="overflow-hidden h-64 relative">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-slate-900/0 group-hover:bg-slate-900/50 transition-all duration-300 flex items-end">
                    <div className="p-5 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300 w-full">
                      <span className="text-xs font-bold uppercase tracking-widest text-[#00A2E8] bg-white px-2 py-1">{item.category}</span>
                    </div>
                  </div>
                </div>
                <div className="p-5 border-t border-slate-200">
                  <h3 className="font-bold text-slate-900 text-sm mb-1">{item.title}</h3>
                  <p className="text-xs text-slate-500">{item.location}</p>
                </div>
              </div>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="text-center py-16 text-slate-500">
              <p className="text-base">No projects in this category yet. Check back soon!</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-slate-50 border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 p-10 border-2 border-slate-200 hover:border-[#00A2E8] transition-colors duration-300">
            <div>
              <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight mb-2">
                Ready to Add Your Project to Our Portfolio?
              </h2>
              <p className="text-slate-500 text-sm">Contact us today for your free consultation and quote.</p>
            </div>
            <Link
              to="/contact"
              data-testid="portfolio-cta-btn"
              className="shrink-0 bg-[#00A2E8] hover:bg-[#0088C4] text-white px-8 py-4 font-bold text-sm tracking-widest transition-colors duration-200 flex items-center gap-2"
            >
              START YOUR PROJECT <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

    </main>
  );
}
